import {
  PatientDiagnosis,
  PatientDiagnosisControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientDiagnosesUpdate = () =>
  useMutationWithLoading(
    async (params: {
      patientDiagnosis: PatientDiagnosis;
      xTENANTID?: string;
    }) =>
      new PatientDiagnosisControllerApi(
        getConfigObject()
      ).updatePatientDiagnosis(params?.patientDiagnosis, params.xTENANTID)
  );
